module.exports = __webpack_public_path__ + "img/bluechipcar-logo.a7da1697.png";